import { type VariantProps, cva } from 'class-variance-authority';

export const inputStyles = cva(
  [
    'input',
    'text-black text-body-responsive',
    'border',
    'rounded-[6px]',
    'focus:outline-none',
    'focus:border-blue-300 focus:border',
  ],
  {
    variants: {
      hasStartIcon: {
        true: ['pl-[42px]'],
        false: ['pl-[12px]'],
      },
      placeholderColor: {
        black: ['placeholder:text-black'],
        grey700: ['placeholder:text-grey-700'],
      },
      hasEndIcon: {
        true: ['pr-[38px]'],
        false: ['pr-[12px]'],
      },
      intent: {
        primary: ['px-[12px]', 'py-[10px]', 'shadow-xs', 'h-[44px]', 'border-grey-400'],
        primaryWhite: ['px-[12px]', 'py-[10px]', 'shadow-xs', 'h-[44px]', 'border-grey-400', 'bg-white'],
        search: ['py-[8px]', 'pr-[16px]', 'pl-[38px]', 'h-[40px]', 'border-grey-400'],
        searchLarge: ['py-[8px]', 'pr-[16px]', 'pl-[46px]', 'h-[40px]', 'border-grey-400', 'bg-white'],
        secondary: ['px-[12px]', 'py-[10px]', 'shadow-xs', 'h-[44px]', 'border-blue-300'],
        otp: ['w-[66px]', 'h-[72px]', 'p-0', 'text-center', '!text-[30px]', 'border-grey-300', 'focus:border-blue-500'],
        old: [
          'px-[16px]',
          'py-[12px]',
          'h-[56px]',
          '!bg-[#F5F5F5]',
          'border-[#F5F5F5]',
          'focus:border-[#F5F5F5]',
          '!rounded-[4px]',
          '!font-trade-pro',
          '!font-light',
          '!text-[14px]',
          '!text-neutral-800',
          '!placeholder:text-neutral-800',
          '!placeholder:font-light',
          '!placeholder:text-[14px]',
        ],
        payment: [
          'px-[12px]',
          'py-[10px]',
          'text-grey-700',
          'h-[44px]',
          'border-grey-400',
          'text-sm',
          'font-normal',
          'leading-[140%]',
          'tracking-[4px]',
        ],
      },
      size: {
        full: ['w-full'],
      },
      otpError: {
        false: ['bg-white'],
        true: ['border-red-500 bg-red-50'],
      },
      error: {
        false: null,
        true: ['border-red-500'],
      },
      disabled: {
        false: null,
        true: [
          'disabled:cursor-not-allowed',
          'disabled:bg-grey-200',
          'disabled:border-grey-400',
          'disabled:placeholder:text-neutral-700',
          'disabled:text-neutral-700',
        ],
      },
    },
    defaultVariants: {
      disabled: false,
      intent: 'primary',
      size: 'full',
      placeholderColor: 'grey700',
    },
  }
);

export const labelStyles = cva(['label block text-left'], {
  variants: {
    intent: {
      primary: ['text-body-small', 'text-blue-900', 'mb-2'],
      old: ['text-tp-body-small', 'text-blue-700', 'text-left', 'mb-3'],
    },
    required: {
      true: ['after:content-["*"]', 'after:text-red-500'],
      false: null,
    },
  },
  defaultVariants: {
    intent: 'primary',
    required: false,
  },
});

export type LabelVariantsProps = VariantProps<typeof labelStyles>;
export type InputVariantsProps = VariantProps<typeof inputStyles>;
